// Shared inner body for the Oscar account email detail page. Renders inside
// AccountPageBody (the account side-nav shell) without the document chrome --
// each site wraps this in its own PageSkeleton so the DOM is byte-identical to
// the pre-move AccountPageShell.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountPageBody } from "../AccountPageBody";

type IProps = Immutable<templates.EmailDetailDocumentTemplate>;

export const EmailDetailBody = (props: IProps): React.JSX.Element => {
    const {
        subject,
        date_sent,
        body_html,
        date_sent_label,
        subject_label,
        body_label,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            <table className="table table-striped table-bordered">
                <tbody>
                    <tr>
                        <th>{date_sent_label}</th>
                        <td>{date_sent}</td>
                    </tr>
                    <tr>
                        <th>{subject_label}</th>
                        <td>{subject}</td>
                    </tr>
                    <tr>
                        <th>{body_label}</th>
                        <td>
                            {/*
                             * Stored email HTML is a full document; render it
                             * into an isolated iframe (srcDoc) so its CSS does
                             * not bleed into the account page -- this is what
                             * the stock email_detail.html iframe + preview JS
                             * accomplished.
                             */}
                            <iframe
                                id="preview_box"
                                width="100%"
                                height="400"
                                srcDoc={body_html}
                                sandbox=""
                                title={body_label}
                            ></iframe>
                        </td>
                    </tr>
                </tbody>
            </table>
        </AccountPageBody>
    );
};
